import { executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';
import { getFormattedError } from '../../../utils/errorMessage.util';

const responseHandler = (res) => {
  return res.body.data;
};

const responseHandlerPayments = (res) => {
  return res.body;
};
const CONTENT_TYPE = 'application/json';

const makeSessionsSetupCall = (isBagPage, errorMapping) => {
  const fromPage = isBagPage ? 'CART_PAGE' : 'CHECKOUT_PAGE';

  const webService = endpoints.adyenSessions;
  const fullRequest = {
    redirectUrl: fromPage,
  };

  const payload = {
    body: JSON.stringify(fullRequest),
    header: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': CONTENT_TYPE,
    },
    webService: {
      ...webService,
    },
  };

  return executeStatefulAPICall(payload)
    .then((res) => responseHandler(res))
    .catch((err) => {
      throw getFormattedError(err, errorMapping);
    });
};

export const validateMerchant = (errorMapping) => {
  const webService = endpoints.adyenApplePaySessions;

  const payload = {
    header: {
      'Content-Type': CONTENT_TYPE,
    },
    webService: {
      ...webService,
    },
  };

  return executeStatefulAPICall(payload)
    .then((res) => responseHandler(res))
    .catch((err) => {
      throw getFormattedError(err, errorMapping);
    });
};

export function makePaymentsCall(data, isBagPage) {
  const fromPage = isBagPage ? 'CART_PAGE' : 'CHECKOUT_PAGE';

  const { type, subtype } = data?.paymentMethod;
  const paymentsRequest = {
    paymentMethod: {
      type,
      subtype,
    },
    returnUrl: fromPage,
  };

  const webService = endpoints.adyenPayments;

  const payload = {
    body: JSON.stringify(paymentsRequest),
    header: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': CONTENT_TYPE,
    },
    webService: {
      ...webService,
    },
  };
  return executeStatefulAPICall(payload)
    .then((res) => responseHandler(res))
    .catch((err) => {
      throw getFormattedError(err);
    });
}

export function updatePayPalOrder({ pspReference, paymentData, shippingAddress }) {
  const paymentsRequest = {
    paymentData,
    pspReference,
    shippingAddress,
  };

  const webService = endpoints.adyenUpdatePaypalOrder;

  const payload = {
    body: paymentsRequest,
    header: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': CONTENT_TYPE,
    },
    webService: {
      ...webService,
    },
  };
  return executeStatefulAPICall(payload)
    .then((res) => responseHandlerPayments(res))
    .catch((err) => {
      throw getFormattedError(err);
    });
}

export default makeSessionsSetupCall;
